import { Component, OnInit } from '@angular/core';
import { RestclientService } from '../../services/restclient/restclient.service';
import { HttpErrorResponse  } from '@angular/common/http';
import { LoginService } from './login.service';
import { Router } from '@angular/router';
import { VersionCheckService } from 'src/app/services/update/version-check.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  public password : string = '';
  public user : string = '';

  error409 = false;

  constructor(private loginservice: LoginService, private restclient: RestclientService, private router: Router, private versionCheck : VersionCheckService) { 

  }

  ngOnInit(): void {
    this.versionCheck.initVersionCheck();
  }

  /**test4 test4 */
  sendLogin(){
      this.loginservice.login(this.user, this.password).subscribe(
        (result) => {
          //console.log("logged in");
          localStorage.setItem('access_token', result.access_token);
          this.router.navigate(['/main']);
        },
        (error : HttpErrorResponse) => {
          //console.error(error);
          if(error.status === 409)
          {
           this.error409 = true;
          }
        }
      );
    }

    sendForcedLogin(){
      this.loginservice.forcedLogin(this.user, this.password).subscribe(
        (result) => {
          //console.log("logged in");
          localStorage.setItem('access_token', result.access_token);
          this.router.navigate(['/main']);
        },

      );
    }

  }